<ng-container *ngIf="showLabel">
  {{ pointsLabel }}
</ng-container>
